import { render } from "./ordentrabajoseguimientoestudio.vue?vue&type=template&id=55892332&scoped=true"
import script from "./ordentrabajoseguimientoestudio.vue?vue&type=script&lang=js"
export * from "./ordentrabajoseguimientoestudio.vue?vue&type=script&lang=js"

import "./ordentrabajoseguimientoestudio.vue?vue&type=style&index=0&id=55892332&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55892332"]])

export default __exports__